<ax-icon class="icon" [name]="iconClass"></ax-icon>
